import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export const calculatePriceAmount = _ref => {
  let {
    items,
    ceiling
  } = _ref;
  let price;
  if (!ceiling && items && items.length) {
    price = items[0];
  } else {
    price = items === null || items === void 0 ? void 0 : items.find(item => item.floor <= ceiling && item.ceiling >= ceiling);
  }
  // If no price is found, return 0
  if (!price) {
    return {
      amount: 0,
      isFlatAmount: false,
      currentTierCeiling: 0,
      currentTierFloor: 0
    };
  }
  if (price.flatAmount !== null) {
    return {
      amount: price.flatAmount,
      isFlatAmount: true,
      currentTierCeiling: price.ceiling,
      currentTierFloor: price.floor
    };
  }
  const perUnitTiers = items.filter(tier => tier.flatAmount === null).map((tier, index) => index === 0 ? _objectSpread(_objectSpread({}, tier), {}, {
    floor: 1
  }) : tier);
  return {
    amount: calculatePerUnitPricing(ceiling, perUnitTiers),
    isFlatAmount: false,
    currentTierCeiling: price.ceiling,
    currentTierFloor: price.floor
  };
};

/** For unitAmount calculation, firstly the tiers are filtered to remove the flatAmount tier, and the first tier is modified to start from 1.
 * Then, the amount is calculated by iterating through the reverse tiers and adding the price for each tier.
 *
 * For.eg
 * const users = 23;
 * const tiers = [
 * {
 *  floor: 1,
 *  ceiling: 10,
 *  flatAmount : 10
 * },{
 *  floor: 11,
 *  ceiling: 20,
 *  unitAmount: 5
 * },{
 *  floor: 21,
 *  ceiling: 30,
 *  unitAmount: 4
 * }
 * ]
 *
 * calculatePerUnitPricing(ceiling, perUnitTiers) where users = 23, tiers = [{floor: 1, ceiling: 20, unitAmount: 5}, {floor: 21, ceiling: 30, unitAmount: 4}]
 *
 * Result amount calculation:
 * calculatePerUnitPricing(users, tiers) => (20 * 5) + (3 * 4) => 100 + 12 => 112
 *
 */
const calculatePerUnitPricing = (users, tiers) => {
  const reverseTiers = [...tiers].reverse();
  let amount = 0;
  let remainingUsers = users;
  reverseTiers.forEach(tier => {
    if (remainingUsers >= tier.floor) {
      const usersInTier = remainingUsers - tier.floor + 1;
      const priceForUsersInTier = usersInTier * tier.unitAmount;
      amount += priceForUsersInTier;
      remainingUsers -= usersInTier;
    }
  });
  if (remainingUsers > 0) {
    throw new Error("Available pricing tiers do not cover all users in team of size ".concat(users));
  }
  return amount;
};